<template>
    <section class="main-box-vc">
        <div class="table-cell">
            <div class="main-box">
                <div class="main-box-content">
                    <h3 class="uppercase">Indian Creek Plaza Bricks</h3>
                    <h4>Building Caldwell's Future One Brick at a Time!</h4>
                    <router-link to="/about" class="btn btn-outline-white">GET STARTED</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'home'
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Home.vue?5122297d